import { useEffect, useState } from "react";
// import Lottie from "react-lottie";
import Animation from "@/assets/animation/Animation1.json";
import { useNavigate } from "react-router-dom";

type CustomToastProps = {
  message: string;
  // path: string;
  timer: number;
  onClose: () => void;
};

const CustomToast = ({ message, timer,  onClose }: CustomToastProps) => {
  // const navigate = useNavigate();
  const [showMessage, setShowMessage] = useState(false);

  const defaultAnimation = {
    loop: false,
    autoplay: true,
    animationData: Animation,
  };

  useEffect(() => {
    const showTextTimeout = setTimeout(() => {
      setShowMessage(true);
    }, 2800); // Show message after 2.8 seconds

    const navigateTimeout = setTimeout(() => {
      onClose();
      // navigate(path);
    }, timer); // Navigate after specified timer

    return () => {
      clearTimeout(showTextTimeout);
      clearTimeout(navigateTimeout);
    };
  }, [timer,  onClose,]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
      <div className="w-[350px] h-[180px] bg-white border border-[#EDEDED] rounded-xl py-10 px-6 max-w-[600px] shadow-md text-center">
        {/* <Lottie options={defaultAnimation} height={80} /> */}
        <p
          className={`text-lg font-medium transition-all duration-500 ease-in-out transform ${
            showMessage
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-2"
          }`}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default CustomToast;
